import { Logger } from 'sierra-client/core/logging/logger'
export const reportsViewInInsightsLogger = Logger.trackLogger<{ reportId: string }>('report_view_in_insights')
